

























import VueOptions from '@utils/VueOptions'
import SpaceFields from '@ui/FormBuilder/ResourceFields/SpaceFields.coffee'
import FormField from '@ui/FormBuilder/FormField'
import OmnichannelSpaceAvailabilityBindSelector from '@ui/ResourceBindSelector/OmnichannelSpaceAvailabilityBindSelector'

settings =
  name: 'SetupForm'

  vue:
    props: ['wizard', 'form', 'options', 'actions']

    components: {
      FormField,
      OmnichannelSpaceAvailabilityBindSelector,
    }

    computed:
      hideAvailabilitiesBind: ->
        !!@options?.hideAvailabilitiesBind

      errors: -> {}

      fieldKeys: ->
        @compact([
          'segment'
          'omnichannel'
          'omnichannel_national' unless @hideAvailabilitiesBind
        ])

      formFields: ->
        fields = {}
        fields[key] = @spaceFields.fields[key] for key in @fieldKeys
        fields.segment.options.instructions = 'Name your social & digital grouping'
        fields

      contextForSpaceFields: ->
        inputProps:
          omnichannel:
            context:
              supplierId: @wizard.supplierId

      spaceFields: ->
        SpaceFields(@contextForSpaceFields)

      isNational: ->
        !!@form.data?.omnichannel_national

      optionsForBindSelector: ->
        supplierId: @wizard.supplierId

    methods:
      saveField: (fieldName) ->
        if @actions?.saveField
          @actions.saveField fieldName
        else
          @wizard.saveField fieldName

export default VueOptions.vue settings
